/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function faqs() {
  $('.toggles__toggle, .faq__answer').hide();
  $('.toggles:nth-of-type(1) .toggles__toggle').show();
  $('.toggles, .faq').on('click tap', function () {
    $(this).toggleClass('active');
    $(this).find('.toggles__toggle, .faq__answer').slideToggle();
  });
}
